// extracted by mini-css-extract-plugin
export default {"rating":"aK-z","numberOfStars":"bK-z","count":"cK-z","barGraphSpacing":"dK-z","barGraph":"eK-z"};